import { components } from '@doltech/dto';
import { components as pageManagementComponents } from '@doltech/pageManagement/dto';
import { StaticPageLink } from '@doltech/routeDefinition';
import { useScrollToLocationHashOnMount } from '@doltech/ui/lib/figma/Layout/Landing/Content/useScrollToLocationHashOnMount';
import { PageLoader } from '@doltech/ui/lib/figma/PageLoader/PageLoader';
import {
  SkillEnum,
  SpeakingSampleTypeEnum,
  WritingSampleTypeEnum,
} from '@doltech/utils/lib/constants';
import dynamic from 'next/dynamic';
import * as React from 'react';

import { ERROR_NOT_SUPPORTED } from '../question-data-model/constants';

const SpeakingPart1PreviewUI = dynamic<any>(
  () =>
    import('./Speaking/Steps/Preview/SpeakingPart1Preview').then(
      (mod) => mod.SpeakingPart1PreviewUI
    ),
  { loading: () => <PageLoader /> }
);

const SpeakingPart2PreviewUI = dynamic<any>(
  () =>
    import('./Speaking/Steps/Preview/SpeakingPart2Preview').then(
      (mod) => mod.SpeakingPart2PreviewUI
    ),
  { loading: () => <PageLoader /> }
);

const WritingTask1PreviewUI = dynamic<any>(
  () =>
    import('./Writing/Steps/Preview/WritingTask1Preview').then((mod) => mod.WritingTask1PreviewUI),
  { loading: () => <PageLoader /> }
);

const WritingTask1GeneralPreviewUI = dynamic<any>(
  () =>
    import('./Writing/Steps/Preview/WritingTask1GeneralPreview').then(
      (mod) => mod.WritingTask1GeneralPreviewUI
    ),
  { loading: () => <PageLoader /> }
);

const WritingTask2PreviewUI = dynamic<any>(
  () =>
    import('./Writing/Steps/Preview/WritingTask2Preview').then((mod) => mod.WritingTask2PreviewUI),
  { loading: () => <PageLoader /> }
);


const renderWritingSample = (type, props) => {
  switch (type) {
    case WritingSampleTypeEnum.WRITING_TASK_1: {
      return <WritingTask1PreviewUI {...props} />;
    }
    case WritingSampleTypeEnum.WRITING_TASK_2_ACADEMIC: {
      return <WritingTask2PreviewUI {...props} />;
    }
    case WritingSampleTypeEnum.WRITING_TASK_1_GENERAL: {
      return <WritingTask1GeneralPreviewUI {...props} />;
    }
    default:
      return <div>{`${ERROR_NOT_SUPPORTED} Writing ${type}`}</div>;
  }
};

const renderSpeakingSample = (type, props) => {
  switch (type) {
    case SpeakingSampleTypeEnum.SPEAKING_PART_1:
    case SpeakingSampleTypeEnum.SPEAKING_PART_3: {
      return <SpeakingPart1PreviewUI {...props} />;
    }
    case SpeakingSampleTypeEnum.SPEAKING_PART_2: {
      return <SpeakingPart2PreviewUI {...props} />;
    }
    default:
      return <div>{`${ERROR_NOT_SUPPORTED} Speaking ${type}`}</div>;
  }
};


interface FullIeltsSamplePreviewUIProps {
  detailData: components['schemas']['SampleDTO'];
  seoData?: pageManagementComponents['schemas']['SampleSEOPageDTO'];
  staticPageLink?: StaticPageLink;
}

const FullIeltsSamplePreviewUIBody = (props: FullIeltsSamplePreviewUIProps) => {
  const { detailData } = props;

  if (detailData.contentGroup === SkillEnum.WRITING) {
    const data = detailData as components['schemas']['WritingSampleDTO'];
    return renderWritingSample(data.type, props);
  }

  if (detailData.contentGroup === SkillEnum.SPEAKING) {
    const data = detailData as components['schemas']['SpeakingSampleDTO'];
    return renderSpeakingSample(data.type, props);
  }

  return <div>{`${ERROR_NOT_SUPPORTED} content group`}</div>;
};

export const FullIeltsSamplePreviewUI = (props: FullIeltsSamplePreviewUIProps) => {
  const { detailData, ...rest } = props;
  useScrollToLocationHashOnMount();
  return <FullIeltsSamplePreviewUIBody detailData={detailData} {...rest} />;
};
